import "./DesktopMenuHeaderComponent.scss";
import DropdownComponent from "../../../DropdownComponent/DropdownComponent";
import { useContext } from "react";
import { AppContext } from "../../../../contexts/appContext";
import { useState } from "react";

/**
 * @function DesktopMenuHeaderComponent DesktopMenuHeader components
 * @param info information that arrives procedurally provided
 * @returns {JSX.Element}
*/
const DesktopMenuHeaderComponent = () => {
  const { menu } = useContext(AppContext);
  const [openMenu, setOpenMenu] = useState(-1);
  let isLast = false;

  return (
    <div>
      <ul className="nav headerBottom__item--menuItem desktop d-none d-sm-none d-md-none d-lg-flex">
        {
          menu?.map((item, index) => {
            const { etichetta, voci, tipologia} = item;
            if (menu.length === index + 1)
              isLast = true;
            return (
              <li className="nav-item" key={ etichetta }>
                <DropdownComponent tipologia = {tipologia} etichetta={ etichetta } voci={ voci } openMenu={ openMenu } setOpenMenu={ setOpenMenu } index={ index } last={isLast}></DropdownComponent>
              </li>
            );
          })
        }
      </ul>
    </div>
  );
};


export default DesktopMenuHeaderComponent;